import { styled, css, keyframes } from 'next-yak'

import * as breakpoint from '../constants/breakpoints'
import * as color from '../constants/colors'
import * as copy from '../styles/copy'

import * as utils from '../utils'

// PagedCarousel styles
export const PagedWrapper = styled.div`
  position: relative;

  @media screen and (${breakpoint.TABLET}) {
    display: grid;
    gap: 20px;
    align-items: center;
    grid-template-columns: 1fr;
  }
`

type PagedControlsProps = { fixedControls?: boolean }

const pagedControls = css<PagedControlsProps>`
  position: absolute;
  z-index: 1;
  top: ${({ fixedControls }) => (fixedControls ? '260px' : '50%')};
  transform: translateY(-50%);
`

export const PagedControlPrev = styled.div<PagedControlsProps>`
  ${pagedControls};

  left: -27px;
`

export const PagedControlNext = styled.div<PagedControlsProps>`
  ${pagedControls};

  right: -27px;
`

const fade = keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`

const next = keyframes`
    from {
        opacity: 0;
        transform: translate3d(150px, 0, 0);
    }
    to {
        opacity: 1;
        transform: translate3d(0, 0, 0);
    }
`

const prev = keyframes`
    from {
        opacity: 0;
        transform: translate3d(-150px, 0, 0);
    }

    to {
        opacity: 1;
        transform: translate3d(0, 0, 0);
    }
`

export const PagedSlide = styled.div`
  & > * {
    animation-duration: 0.2s;
    animation-timing-function: ease-in-out;
    animation-fill-mode: forwards;
  }
  &[data-animation='fade'] > * {
    animation-name: ${fade};
  }
  &[data-animation='next'] > * {
    animation-name: ${next};
  }
  &[data-animation='prev'] > * {
    animation-name: ${prev};
  }
`

export const PagedLabel = styled(copy.S.regular)`
  background-color: ${() => utils.colors.hexToRgb(color.PRIMARY_GREY_900, 0.54)};
  border-radius: 28px;
  color: ${color.PRIMARY_GREY_000};
  padding: 10px 20px;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  text-overflow: ellipsis;
  display: -webkit-box;
`

export const PagedLabelContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  position: absolute;
  bottom: 16px;
  right: 16px;
  left: 16px;
`

// SlidingCarousel styles

export const SlidingControlWrapper = styled.div`
  width: 89%;
  max-width: 1330px;
  position: relative;
  margin: auto;
`

export const SlidingWrapper = styled.div`
  display: flex;
  flex-direction: column-reverse;
  position: relative;

  @media screen and ${breakpoint.LAPTOP} {
    flex-direction: column;
  }
`

export const SlidingCarouselWrapper = styled.div<{ $verticalOnMobile?: boolean }>`
  display: flex;
  overflow-x: scroll;
  scroll-behavior: smooth;
  scrollbar-width: none;
  width: 100%;

  ::-webkit-scrollbar {
    display: none;
  }

  ${({ $verticalOnMobile = false }) => {
    if ($verticalOnMobile) {
      return css`
        @media not screen and ${breakpoint.TABLET} {
          flex-direction: column;
        }
      `
    }
  }};
`

export const SlidingControlButtons = styled.div`
  bottom: 0;
  display: flex;
  gap: 16px;
  left: 0;
  margin-left: auto;
  margin-top: 24px;
  width: fit-content;

  @media screen and ${breakpoint.LAPTOP} {
    bottom: initial;
    left: initial;
    margin: 0;
    position: absolute;
    right: 0;
    top: -80px;
  }
`
